export default __webpack_public_path__ + "static/media/head2.8321a768.svg";